<p-panel header="{{ 'I18nValue.basicData' | hisUi }}">

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<his-plam>
		<textarea #content hisDdKey="fs.res.patent.Patent.title"
			[(ngModel)]="patent.title" class="textareaWidth100" rows="1"></textarea>
	</his-plam>

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<!-- field is automatically set, required attribute used to show field as required, no validation -->
	<his-plam>
		<input #content hisDdKey="fs.res.patent.Patent.priorityPatent" class="inputWidth100" required
			value="{{ !patent.priorityPatent ? ('de.his.javang.ja.lowercase' | hisUi) : ('de.his.javang.nein.lowercase' | hisUi) }}" disabled/>
	</his-plam>

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

 	<his-plam>
 		<p-calendar #content hisDdKey="fs.res.patent.Patent.registrationDate"
			[(ngModel)]="patent.registrationDate"></p-calendar>
	</his-plam>

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<his-plam [required]="isGranted()">
		<p-calendar #content hisDdKey="fs.res.patent.Patent.grantDate"
			[(ngModel)]="patent.grantDate" (ngModelChange)="grantDateChanged($event)"></p-calendar>
	</his-plam>

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<his-plam *ngIf="patent.priorityPatent">
		<p-calendar #content hisDdKey="fs.res.patent.Patent.priorityPatent.registrationDate"
			[ngModel]="patent.priorityPatent.registrationDate" [disabled]="!!patent.priorityPatent"></p-calendar>
	</his-plam>

	<ng-container *ngIf="patent.priorityPatent">
		<!-- #anchor dynamic field container -->
		<ng-template #dynamicFieldContainer></ng-template>
	</ng-container>

	<his-plam>
		<p-autoComplete #content hisDdKey="fs.res.patent.Patent.language"
			[(ngModel)]="patent.language" hisEagerDataSource="language" (onClear)="onClear('language')">
		</p-autoComplete>
	</his-plam>

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<his-plam *ngIf="patent.priorityPatent">
 		<input #content hisDdKey="fs.res.patent.Patent.priorityPatent.patentNumber"
 			[ngModel]="patent.priorityPatent.patentNumber" class="inputWidth100" disabled>
 	</his-plam>

 	<ng-container *ngIf="patent.priorityPatent">
		<!-- #anchor dynamic field container -->
		<ng-template #dynamicFieldContainer></ng-template>
	</ng-container>

 	<!-- patent number -->
	<his-plam *ngIf="!patent.priorityPatent; else priorityPatentNumber">
		<input #content hisDdKey="fs.res.patent.PriorityPatent.patentNumber"  
			[(ngModel)]="patent.patentNumber" class="inputWidth100">
	</his-plam>
	<ng-template #priorityPatentNumber>
		<his-plam *ngIf="patent.priorityPatent">
			<input #content hisDdKey="fs.res.patent.Patent.patentNumber"
				[(ngModel)]="patent.patentNumber" class="inputWidth100">
		</his-plam>
	</ng-template>

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<his-plam [required]="isGranted()">
		<input #content hisDdKey="fs.res.patent.Patent.publicationNumber"
			[(ngModel)]="patent.publicationNumber" class="inputWidth100">
	</his-plam>

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<his-plam>
		<p-autoComplete #content hisDdKey="fs.res.patent.Patent.status" [disabled]="!!patent.grantDate"
			[(ngModel)]="patent.status" hisEagerDataSource="patentStatusValue"
			(onClear)="onClear('status')">
		</p-autoComplete>
	</his-plam>

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<his-plam>
		<p-autoComplete #content hisDdKey="fs.res.patent.Patent.visibilityValue"
			[(ngModel)]="patent.visibilityValue" hisEagerDataSource="visibilityValue"
			(onClear)="onClear('visibilityValue')">
		</p-autoComplete>
	</his-plam>

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

    <his-plam>
        <p-autoComplete #content hisDdKey="fs.res.patent.Patent.registrationType"
            [(ngModel)]="patent.registrationType" hisEagerDataSource="patentRegistrationTypeValue"
            (onClear)="onClear('patentRegistrationTypeValue')">
        </p-autoComplete>
    </his-plam>
    
	<his-plam #country *ngIf="isCountrySpecific()" [required]="isCountrySpecific()">
		<p-autoComplete #content hisDdKey="fs.res.patent.Patent.country"
			[(ngModel)]="patent.country"  hisEagerDataSource="country"
			(onClear)="onClear('country')">
		</p-autoComplete>
	</his-plam>

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<his-plam>
		<textarea hisDdKey="fs.res.patent.Patent.commentary" #content class="textareaWidth100" rows="4" ngModel
		[hisObject]="patent" hisAttribute="commentary"></textarea>
	</his-plam>

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

</p-panel>
